import EnergyOffersTable from '../../OffersList/Energy/EnergyOffersTable'
import ProviderShow from '../ProviderShow'

const EnergyShow = () => <ProviderShow OffersTableComponent={EnergyOffersTable} />

export default EnergyShow
